import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [checking, setChecking] = useState(true);
  const [error, setError] = useState(null);
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    // Confirm payment - if user reached this page, payment was successful
    const confirmPayment = async () => {
      try {
        console.log('Attempting to confirm payment...');
        const token = localStorage.getItem('token');
        
        if (!token) {
          console.error('No auth token found!');
          setError('Not authenticated');
          setChecking(false);
          return;
        }
        
        // Simply confirm the most recent awaiting payment order
        // PayMongo only redirects here if payment succeeded
        const response = await axios.post(
          `${process.env.REACT_APP_API}/api/payments/confirm-payment`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        console.log('Payment confirmation response:', response.data);
        
        if (response.data.success) {
          console.log(`✅ Order ${response.data.orderId} confirmed as paid`);
          setConfirmed(true);
        } else {
          console.warn('Payment confirmation failed:', response.data.message);
          setError(response.data.message);
          // Fallback: trigger server-side sync in case payment just finalized but confirm endpoint missed it
          await fallbackSync();
        }
      } catch (error) {
        console.error('❌ Error confirming payment:', error);
        console.error('Error details:', error.response?.data);
        setError(error.response?.data?.message || error.message);
        // Fallback on error as well
        await fallbackSync();
      } finally {
        setChecking(false);
      }
    };

    confirmPayment();

    const timer = setTimeout(() => {
      navigate('/orders', { replace: true });
    }, 3000); // Redirect after 3 seconds to give time for confirmation

    return () => clearTimeout(timer);
  }, [navigate, searchParams]);

  const fallbackSync = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      console.log('Running fallback payment sync...');
      const res = await axios.post(
        `${process.env.REACT_APP_API}/api/payments/sync-payment-status`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.updated) {
        console.log('✅ Fallback sync updated an order to paid');
        setConfirmed(true);
        setError(null);
      } else {
        console.log('Fallback sync found no updates:', res.data.message);
      }
    } catch (e) {
      console.error('Fallback sync error:', e.response?.data || e.message);
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #7ba93a 0%, #5a7f2a 100%)',
      color: 'white',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '3rem 2rem',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        maxWidth: '500px',
        width: '100%'
      }}>
        <div style={{ fontSize: '5rem', marginBottom: '1rem' }}>✅</div>
        <h1 style={{ color: '#7ba93a', marginBottom: '1rem', fontSize: '2rem' }}>
          Payment Successful!
        </h1>
        <p style={{ color: '#666', fontSize: '1.1rem', marginBottom: '2rem' }}>
          {checking 
            ? '⏳ Confirming your payment...' 
            : confirmed
              ? '✅ Your payment has been confirmed! Thank you for your order!'
              : error 
                ? `⚠️ ${error}` 
                : 'Your payment has been processed successfully. Thank you for your order!'}
        </p>
        <p style={{ color: '#888', fontSize: '0.9rem' }}>
          Redirecting to your orders in 3 seconds...
        </p>
        <button
          onClick={() => navigate('/orders')}
          style={{
            marginTop: '1.5rem',
            padding: '12px 32px',
            background: '#7ba93a',
            color: 'white',
            border: 'none',
            borderRadius: '24px',
            fontSize: '1rem',
            fontWeight: 600,
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(123,169,58,0.3)'
          }}
        >
          View Orders Now
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
